import { createI18n } from 'vue-i18n'
import type { I18n, I18nOptions, Locale, Composer } from "vue-i18n";

export function setI18nLanguage(i18n: I18n, locale: Locale): void {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    ((i18n.global as unknown) as Composer).locale.value = locale
  }
}

export function setupI18n(options: I18nOptions = { locale: 'en' }): any {
  // get language from device before loading messages
  return new Promise((resolve, reject): any => {
    const lang = navigator.language || 'en'; // PUT THIS ON AGAIN
    // const lang ='en';
    const i18n = createI18n(options) as I18n;
    options.locale = lang;
    console.log("options.locale", options.locale);
    setI18nLanguage(i18n, options.locale!);
    resolve(i18n);
  });
}

export async function loadLocaleMessages(i18n: I18n, locale: Locale) {
  // load locale messages
  console.log("LOCAL AVAIL", i18n.global.availableLocales.includes);
  if (!i18n.global.availableLocales.includes(locale)) {
    const messages = await import(`@/assets/i18n/${locale}`)
    i18n.global.setLocaleMessage(locale, messages.default)
  }

}
